import React from "react";

const Cadrage = () => {

    return(
        <>
            <div className="">
  {/*section banner*/}
  <section className="be-banner">
    <div className="">
      <p className="be-banner-title">CHIFFRAGE : CHARPENTE TRADITIONNELLE</p>
      <p className="be-centered-p">CADRAGE DU PROJET</p>
    </div>
  </section>
  {/*container*/}
  <div className="container py-5">
    <div className="py-5">
      <p className="page-title text-center">Information préalable :</p>
      <p className="grey-text text-center">
        En tant que négoce, nous ne nous substituons pas au maitre d’œuvre. Nous
        ne réalisons pas les <br /> plans de permis de construire et ne faisons
        pas de pose sur chantier.
      </p>
    </div>
  </div>
  <div className="container">
    <div className="form-head">
      <p className="text-center">
        Veuillez renseigner les informations suivantes pour nous aider à mieux
        comprendre votre demande
      </p>
    </div>
    <div className="be-form p-3 p-md-5">
      <form action="">
        <div className="row">
          <div className="col-md-8 col-12 mb-3">
            <p className="be-form-p">Adresse du Chantier</p>
            <input type="text" className="p-3" />
          </div>
          <div className="col-md-4 col-12 mb-3">
            <p className="be-form-p">Code Postal</p>
            <input type="text" className="p-3" />
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-md-8 col-12 mb-3">
            <p className="be-form-p">
              À quelle étape de votre projet êtes-vous ?
            </p>
            <div className="custom-select">
              <div className="select-trigger">Choisir une option</div>
              <ul className="options">
                <li>Option 1</li>
                <li>Option 2</li>
                <li>Option 3</li>
              </ul>
            </div>
          </div>
          <div className="col-md-4 col-12 mb-3">
            <p className="be-form-p">Date prévisionnelle du Chantier</p>
            {/* <input type="text" placeholder="../../.." id="datepicker" class="p-3"> */}
            <input type="date" className="p-3" />
          </div>
        </div>
        <hr className="my-5" />
        <div className="row mb-5">
          <div className="col-12 mb-3">
            <p className="be-form-p">Reference de Chantier</p>
            <input type="text" className="p-3" />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-md-6 col-12 mb-3">
            <p className="be-form-p">Disposez-vous déjà d'un poseur ?</p>
            <div className="custom-select">
              <div className="select-trigger">Choisir une option</div>
              <ul className="options">
                <li>Option 1</li>
                <li>Option 2</li>
                <li>Option 3</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 col-12 mb-3">
            <p className="be-form-p">Souhaitez-vous le d'un poseur ?</p>
            <div className="custom-select">
              <div className="select-trigger">Choisir une option</div>
              <ul className="options">
                <li>Option 1</li>
                <li>Option 2</li>
                <li>Option 3</li>
              </ul>
            </div>
          </div>
        </div>
        <span className="grey-text" style={{ fontSize: 12 }}>
          Un poseur est très fortement recommandé pour cette typologie de projet
        </span>
      </form>
    </div>
  </div>
  {/* content close */}
  <a href="#" id="back-to-top" className="show" />
</div>

        </>
    )

}

export default Cadrage;